export const orange = "#f07500";
export const forestGreen = "#2e7d32";
export const purple = "#703fb5";
export const lightBlue = "#00ebf5";
export const kiwiGreen = "#2ed851";
export const brown = "#6d4c41";
export const blue = "#0288d1";
export const smoke = "#212121";
export const red = "#b12c2c";